<template>
  <div class="text-center">
    <b-row no-gutters align-v="center" align-h="center">
      <b-col cols="12" align-self="center" class="p-3 bg-warning-light font-weight-bold"
        ><b-link :href="`${baseLocaleUrl()}/order/${orderId}/store/tags/pet/${pet.id}`" class="text-secondary"
          ><u>{{ $tc('components.petFooter.addDesignerTag', bundleCount > 0 ? 2 : 1, { petName: pet.name }) }}</u></b-link
        ></b-col
      >
    </b-row>
  </div>
</template>

<script>
import baseLocaleUrl from '@/mixins/baseLocaleUrl';

export default {
  mixins: [baseLocaleUrl],
  props: {
    pet: {
      type: Object,
      required: true,
    },
    orderId: {
      type: [String, Number],
      required: true,
    },
    bundleCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.bg-warning-light {
  background-color: $dp-light-yellow;
}
</style>
